"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Tablet48PxOutlinedIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _iconModule = _interopRequireDefault(require("../icon/icon.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["title", "box", "iconState", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,
  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,
  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var defaultProps = {
  title: null,
  box: false
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/tablet/tablet-48px-outlined.91304d6b.svg';
var Tablet48PxOutlinedIcon = exports.Tablet48PxOutlinedIcon = function Tablet48PxOutlinedIcon(_ref) {
  var title = _ref.title,
    box = _ref.box,
    iconState = _ref.iconState,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Tablet Icon',
        width: "48",
        height: "49"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Tablet Icon'
      }))
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Tablet Icon',
    width: "48",
    height: "49"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Tablet Icon'
  }));
};
Tablet48PxOutlinedIcon.displayName = 'Tablet48PxOutlinedIcon';
Tablet48PxOutlinedIcon.propTypes = propTypes;
Tablet48PxOutlinedIcon.defaultProps = defaultProps;
var _default = exports["default"] = Tablet48PxOutlinedIcon;